import { render } from "./ContentFooter.vue?vue&type=template&id=0cf9ec53&scoped=true"
import script from "./ContentFooter.vue?vue&type=script&lang=js"
export * from "./ContentFooter.vue?vue&type=script&lang=js"

import "./ContentFooter.vue?vue&type=style&index=0&id=0cf9ec53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf9ec53"],['__file',"src/pages/Layout/ContentFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0cf9ec53"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0cf9ec53', __exports__)) {
    api.reload('0cf9ec53', __exports__)
  }
  
  module.hot.accept("./ContentFooter.vue?vue&type=template&id=0cf9ec53&scoped=true", () => {
    api.rerender('0cf9ec53', render)
  })

}


export default __exports__